import { render } from "./ScreenKeyboard.vue?vue&type=template&id=06f499c6"
import script from "./ScreenKeyboard.vue?vue&type=script&lang=js"
export * from "./ScreenKeyboard.vue?vue&type=script&lang=js"

import "./ScreenKeyboard.vue?vue&type=style&index=0&id=06f499c6&lang=css"

import exportComponent from "/home/hadams/code/Vuejs_Wordle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__